import { useIsWithinTailWindBreakpoint } from 'noddi-ui-web';

/**
 * Picker steps show their action bar on desktop always, on mobile only once something is
 * selected — customers had trouble seeing slots behind the bar. Back lives in that bar, so a
 * page keeps its header back button while the bar is hidden.
 */
export const useShowsSelectionBottomBar = (hasSelection: boolean) => {
  const isWithinMd = useIsWithinTailWindBreakpoint('md');
  return hasSelection || !isWithinMd;
};
